import { render, staticRenderFns } from "./intelligentPushList.vue?vue&type=template&id=4f6001a4"
import script from "./intelligentPushList.vue?vue&type=script&lang=js"
export * from "./intelligentPushList.vue?vue&type=script&lang=js"
import style0 from "./intelligentPushList.vue?vue&type=style&index=0&id=4f6001a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports